import styled from 'styled-components';
import { fadeIn } from '../../utils/animations';
import { useTranslation } from 'react-i18next';
import React from 'react';

const ProgramsPageContainer = styled.div` /* Renamed */
  width: 100%;
  padding: 2rem; /* Added page padding */
  background-color: ${(props) => props.theme.colors.background}; /* Updated */
  color: ${(props) => props.theme.colors.text}; /* Updated */
  display: flex;
  flex-direction: row; /* Programs side-by-side */
  flex-wrap: wrap; /* Allow wrapping on smaller screens */
  justify-content: center; /* Center cards */
  align-items: flex-start; /* Align cards to the top */
  gap: 2rem; /* Spacing between cards */
  opacity: 0; /* Initial state for page load animation */
  animation: ${fadeIn} 0.5s ease-out forwards; /* Page load animation */
`;

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%; /* Take full width up to max-width */
  max-width: 350px; /* Max width for each card */
  flex: 1 1 300px; /* Flex properties for responsiveness */
  height: auto; 
  padding: 1.5rem; /* Increased padding */
  align-items: center;
  justify-content: flex-start; 
  background-color: ${(props) => props.theme.colors.surface}; /* Updated */
  border-radius: ${(props) => props.theme.borderRadius}; /* Updated */
  animation: ${fadeIn} 0.5s ease-in-out;
  animation-fill-mode: both;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); /* Updated shadow */
  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out; /* Updated transition */

  @media (max-width: 480px) {
    padding: 1rem; /* Adjust padding for smaller screens */
  }
  
  &:hover {
    transform: translateY(-4px); /* Updated hover effect */
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12); /* Updated hover shadow */
  }
`;

const Title = styled.h3`
  font-family: ${(props) => props.theme.fontFamilies.primary}; /* Updated */
  font-size: ${(props) => props.theme.fontSizes.h3}; /* Updated */
  color: ${(props) => props.theme.colors.primary}; /* Updated */
  line-height: ${(props) => props.theme.lineHeights.heading}; /* Updated */
  font-weight: 600;
  margin: 0 0 1rem 0; 
  text-align: center; 
`;

const Image = styled.img`
  width: 100%;
  height: 200px; 
  object-fit: cover;
  border-radius: ${(props) => props.theme.borderRadius}; /* Updated to use theme variable */
  margin-bottom: 1rem; 
`;

const Description = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.secondary}; /* Updated */
  font-size: ${(props) => props.theme.fontSizes.body}; /* Updated */
  color: ${(props) => props.theme.colors.text}; /* Updated */
  line-height: ${(props) => props.theme.lineHeights.body}; /* Updated */
  text-align: center;
  margin: 0; 
  padding: 0 0.5rem; 
  font-weight: normal; 
  white-space: pre-wrap; 
`;

// No explicit props
interface ProgramsProps {}

const ProgramsComponent: React.FC<ProgramsProps> = () => {
  const { t } = useTranslation();
  const gurmatSangeetImgSrc: string = require('../../assets/7.jpg');
  const sundayProgramImgSrc: string = require('../../assets/1.jpeg');
  const weekDayProgramImgSrc: string = require('../../assets/5.jpeg');

  return (
    <ProgramsPageContainer>
      <ItemContainer>
        <Title>{t('programs.sangeetTitle')}</Title>
        <Image src={gurmatSangeetImgSrc} alt={t('programs.sangeetImageAlt') as string} />
        <Description>{t('programs.sangeetDescription')}</Description>
      </ItemContainer>
      <ItemContainer>
        <Title>{t('programs.sundayProgramTitle')}</Title>
        <Image src={sundayProgramImgSrc} alt={t('programs.sundayProgramImageAlt') as string} />
        <Description>{t('programs.sundayProgramDescription')}</Description>
      </ItemContainer>
      <ItemContainer>
        <Title>{t('programs.weekdayProgramTitle')}</Title>
        <Image src={weekDayProgramImgSrc} alt={t('programs.weekdayProgramImageAlt') as string} />
        <Description>{t('programs.weekdayProgramDescription')}</Description>
      </ItemContainer>
    </ProgramsPageContainer>
  );
}

export default React.memo(ProgramsComponent);
